import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgVision(props) {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_jsx("mask", Object.assign({
      id: "vision_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 64,
      height: 64
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h64v64H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#vision_svg__a)",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round"
    }, {
      children: [_jsx("path", {
        d: "M59.506 30.46h-6.641M10.96 30.46H4.32",
        stroke: "#FF6652"
      }, void 0), _jsx("path", {
        d: "M4 41.951h56M8.923 49.56h46.16M17.39 57h29.225",
        stroke: "#7373FF"
      }, void 0), _jsx("path", {
        d: "M17.072 36.745c0-.093-.026-.206-.041-.345a15.674 15.674 0 012.844-10.885c4.378-5.925 11.59-6.033 12.146-6.033.447 0 8.364.149 12.706 6.875a15.528 15.528 0 012.155 10.814M32 7v6.629M16.902 18.332l-4.692-4.688M47.366 18.332l4.697-4.688",
        stroke: "#FF6652"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgVision;